module.exports = __webpack_public_path__ + "img/discounts.b7b0ff39.png";